import { useAuthenticatedUser } from '@omnea-app/fe-auth/UserSessionProvider'
import { useListOrganisationIntegrations } from '@omnea-app/fe-organisation-integrations/useListOrganisationIntegrations'
import {
  AccountingIntegration,
  globalIntegrationsMetadata,
  isAccountingIntegration,
} from '@omnea-app/packages/universal/integrations/globalIntegrations'
import { isDefined } from '@omnea-app/packages/universal/type-guards/isDefined'

interface AccountingIntegrationInfo {
  hasAccountingIntegration: boolean
  integration: { name: string; type: AccountingIntegration } | null
  supportsAddresses: boolean
  isLoading: boolean
}

export const useOrgHasAccountingIntegration = (): AccountingIntegrationInfo => {
  const { user } = useAuthenticatedUser()
  const { data: integrations, isLoading } = useListOrganisationIntegrations({
    enabled: !user.isSupplier,
  })

  const accountingIntegrations = (integrations ?? []).filter(({ integration }) => isAccountingIntegration(integration))

  const accountingIntegration = accountingIntegrations[0]
  const hasAccountingIntegration = accountingIntegrations.length > 0 && isDefined(accountingIntegration)

  if (!hasAccountingIntegration)
    return { hasAccountingIntegration: false, integration: null, supportsAddresses: false, isLoading }

  const integrationName = globalIntegrationsMetadata[accountingIntegration.integration].title
  const integrationType = accountingIntegration.integration as AccountingIntegration
  const supportsAddresses = ['microsoft-dynamics-fo', 'coupa'].includes(accountingIntegration.integration) // TODO: add for NetSuite and Workday when we have support

  return {
    hasAccountingIntegration,
    integration: { name: integrationName, type: integrationType },
    supportsAddresses,
    isLoading,
  }
}
